








































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import { formatCurrency } from "@/shared/currency";

@Component
export default class TabGroup extends Vue {
  @Prop()
  centered: boolean;

  @Prop()
  bottomBorder: boolean;

  @Prop()
  noPadding: boolean;

  @Prop()
  noBorder: boolean;

  @Prop()
  tabContentNoPadding: boolean;

  @Prop({default: false})
  whiteBackgroundWithBorder: boolean;

  selected = 0;
  tabs = [];
  current = null;
  formatCurrency = formatCurrency;

  isTabSelected (index) {
    return this.selected === index;
  }

  created () {
    this.$on("add-tab", this.addTab);
    this.$on("activate-tab", this.activateTab);
  }

  addTab (tab) {
    this.tabs.push(tab);
    if (tab.active === true) {
      this.current = tab;
    }
  }

  activateTab (tab) {
    this.current = tab;
  }

  changeTab (event, tab) {
    this.$parent.$emit("tab-clicked", event, tab);
    this.current = tab;
    this.tabs.forEach(value => {
      if (value === tab) {
        value.active = true;
      } else {
        value.active = false;
      }
    });
  }

  get hasTabNav () {
    return !!this.$slots["tabs-nav"];
  }
}

